import { render } from "./MainContent.vue?vue&type=template&id=c4092bf8&scoped=true&ts=true"
import script from "./MainContent.vue?vue&type=script&lang=ts"
export * from "./MainContent.vue?vue&type=script&lang=ts"

import "./MainContent.vue?vue&type=style&index=0&id=c4092bf8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4092bf8"]])

export default __exports__